module.exports = __webpack_public_path__ + "static/media/upload_more.96956caf.svg";